import { PartnerTypeEnum } from "@boundless/bl-api-client/customer/models"
import {
  prefetchCustomerPerksListQuery,
  useCustomerPerksListSuspense,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { PartnerTypeSection } from "@/components/perks/PartnerTypeSection"

export const Route = createFileRoute("/_dashboard/_customer/perks")({
  component: RouteComponent,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (
      !hasPermissions(["customer_perks.view_perk"]) ||
      !store.getState().perksEnabled
    ) {
      throw redirect({ to: "/" })
    }

    const activeCompanyUuid = store.getState().activeCompanyUuid
    const queryFilter = activeCompanyUuid
      ? { companyUuid: activeCompanyUuid }
      : undefined

    return { queryFilter }
  },
  loader: ({ context: { queryClient, queryFilter } }) => {
    prefetchCustomerPerksListQuery(queryClient, queryFilter)
  },
})

function RouteComponent() {
  const { queryFilter } = Route.useRouteContext()

  const { data: perks } = useCustomerPerksListSuspense(queryFilter)

  // Sort alphabetically, but leave `Other` last
  const perkTypes = Object.values(PartnerTypeEnum).sort((a, b) => {
    if (a === "other") return 1
    if (b === "other") return -1
    return a.localeCompare(b)
  })

  return (
    <div className="flex flex-col gap-5">
      {perkTypes.map((type) => (
        <PartnerTypeSection key={type} type={type} perks={perks} />
      ))}
    </div>
  )
}
